"use client";

import { Button, Input, Badge, Label } from "@wtc/ui";
import { X, Plus } from "lucide-react";

interface MspDocumentTagsSectionProps {
  tags: string[];
  newTag: string;
  setNewTag: (value: string) => void;
  onAddTag: () => void;
  onRemoveTag: (tag: string) => void;
  onKeyPress: (e: React.KeyboardEvent) => void;
}

export function MspDocumentTagsSection({
  tags,
  newTag,
  setNewTag,
  onAddTag,
  onRemoveTag,
  onKeyPress,
}: MspDocumentTagsSectionProps) {
  return (
    <div className="space-y-2">
      <Label>Tags</Label>
      <div className="flex gap-2">
        <Input
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          onKeyPress={onKeyPress}
          placeholder="Add tag..."
        />
        <Button type="button" onClick={onAddTag} size="sm">
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <Badge key={tag} variant="secondary" className="flex items-center gap-1">
              {tag}
              <button
                type="button"
                onClick={() => onRemoveTag(tag)}
                className="hover:bg-card-300 rounded-full p-0.5"
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
